import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=4b7f2d3c&"
import script from "./Button.vue?vue&type=script&setup=true&lang=js&"
export * from "./Button.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=4b7f2d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports